import { Box } from '@mui/material';
import { useIntl } from 'react-intl';
import {
    COURSE_STAGE_VALUES,
    courseStageLabelId,
    courseStageShortLabelId,
} from '../model';

/** Below this width a stage's full name no longer fits over its mark. */
const SHORT_NAMES = '@container (max-width: 799px)';

/**
 * The course stages' names in one row, each centred over the mark a stage
 * strip of the same width draws for it: full names where they fit, short ones
 * where the column is narrow. Hidden from assistive technology, which reads
 * each strip's own summary.
 */
export default function CourseStageHeader() {
    const intl = useIntl();
    return (
        <Box
            component="span"
            aria-hidden
            sx={{
                display: 'flex',
                width: '100%',
                containerType: 'inline-size',
            }}
        >
            {COURSE_STAGE_VALUES.map((stage) => (
                <Box
                    key={stage}
                    component="span"
                    sx={{
                        flex: 1,
                        minWidth: 0,
                        textAlign: 'center',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        fontSize: 11,
                    }}
                >
                    <Box
                        component="span"
                        sx={{ [SHORT_NAMES]: { display: 'none' } }}
                    >
                        {intl.formatMessage({ id: courseStageLabelId(stage) })}
                    </Box>
                    <Box
                        component="span"
                        sx={{
                            display: 'none',
                            [SHORT_NAMES]: { display: 'inline' },
                        }}
                    >
                        {intl.formatMessage({
                            id: courseStageShortLabelId(stage),
                        })}
                    </Box>
                </Box>
            ))}
        </Box>
    );
}
